/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Sent_DescriptionInputs */



/**
* | output |
* | --- |
* | "Thanks, we have your message. You will get a confirmation email with your case number shortly." |
*
* @param {Support_Sent_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const support_sent_description = /** @type {((inputs?: Support_Sent_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Sent_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Danke, deine Nachricht ist bei uns. Du bekommst gleich eine Bestätigung per E-Mail mit deiner Fallnummer.")
	return /** @type {LocalizedString} */ ("Thanks, we have your message. You will get a confirmation email with your case number shortly.")
});